import {useQuery} from "react-query";
import {fetchAllBus} from "../api/customer";

const QUERY_KEY = 'customers'

export const useCustomerList = () => {
    return useQuery([QUERY_KEY], () => fetchAllBus());
};